import React from 'react'

function Manu() {
  return (
    <div style={{color:'white'}}>Manu</div>
  )
}

export default Manu